type BannedShiftState = {
  readonly shiftIds: string[];
  readonly isApplied: boolean;
};

export function withoutBannedShiftsOnAppliedFixedDays<T extends BannedShiftState>(
  bannedByDay: Readonly<Record<number, T>>,
  fixedAppliedByDay: Readonly<Record<number, boolean>>
): Record<number, T> {
  return Object.fromEntries(
    Object.entries(bannedByDay).filter(
      ([day]) => !fixedAppliedByDay[Number(day)]
    )
  );
}
